import Vue from "vue";
import FusenCanvas from "./FusenCanvas.vue";
export default Vue.extend({
    computed: {
        editing: function () {
            return this.$store.state.editing;
        },
        selectedItem: function () {
            return this.$store.state.items[this.$store.state.selectedIndex];
        },
        styleObj: function () {
            var selected = this.selectedItem;
            if (this.selectedItem) {
                return {
                    top: selected.y + "px",
                    left: selected.x + "px",
                    width: selected.w + "px",
                    height: selected.h + "px"
                };
            }
            return {};
        },
        editingText: {
            get: function () {
                return this.$store.state.editingText;
            },
            set: function (value) {
                this.$store.commit('updateEditor', value);
            }
        }
    },
    methods: {
        editItem: function () {
            this.$store.commit("editItem", this.editingText);
        }
    },
    components: {
        FusenCanvas: FusenCanvas
    },
    watch: {
        editing: function (value) {
            var _this = this;
            if (value) {
                Vue.nextTick(function () {
                    var el = (_this.$el.querySelector(".editor__textarea"));
                    el.focus();
                });
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
// module id = 10
// module chunks = 0